import React from 'react';

/**
 * Use this to manage interaction by overlaying an absolute div
 */
export const InteractionPreventer = React.memo(
  (props: { enabled: boolean; children?: React.ReactNode }) => {
    return (
      <>
        {props.children}
        {props.enabled ? (
          <div
            className="rc-absolute rc-h-full rc-w-full"
            style={{ top: 0, left: 0 }}
          />
        ) : null}
      </>
    );
  }
);
